<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="header">
            <div class="title">
                <img :src="haojobLogo" alt="">
                <ul class="tabItem">
                    <li @click="$router.push('/')">首页</li>
                    <li @click="$router.push('/investment')" :class="!appTrueActive?'active':''">招商加盟</li>
                    <li @mouseenter="appDownload"  @mouseleave="leaveDownload" :class="appTrueActive?'active':''">APP下载</li>
                    <li @click="$router.push('/relationPages')">联系我们</li>
                    <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
                </ul>
            </div>
        </div>
        <downloadApp v-if="appTrueActive"></downloadApp>
        <div class="centerFloat">
            <img :src="recruitBanner" alt="" class="bannerBg">
            <div class="centerHead">
                <span class="content">
                    <span class="titleOne"><span>大数据</span><span style="color:#333333;"> 智能匹配 精准推送</span></span>
                    <span class="analyse">对人才数据多维度分析，通过城市合伙人机制，优先满足本地人才本地就业</span>
                    <span class="atOnce" @click="goEnter">立即入驻</span>
                </span>
            </div>
        </div>
        <div class="operation">
            <div class="operationSear">
                <p class="operationTit">运作模式</p>
                <div class="operationCont">
                    <span class="operatLeft">
                        <span class="operatLi" style="padding-top:20px;padding-right:18px;padding-bottom:20px;">
                            <span class="operatLiDt">
                                <span>异地输送</span>
                                <span>本地人才输送外地用工企业外地人才输送本地用工企业</span>
                                <img :src="goldCoin" alt="">
                            </span>
                            <img :src="placeOther" alt="" class="rightImg">
                        </span>
                        <span class="operatLi" style="padding-top:12px;padding-right:13px;padding-bottom:11px;">
                            <span class="operatLiDt">
                                <span>本地输送</span>
                                <span style="margin-bottom:15px;">本地人才输送本地用工企业</span>
                                <img :src="goldCoin" alt="">
                            </span>
                            <img :src="thisPlace" alt="" class="rightImg">
                        </span>
                    </span>
                    <img :src="operationBg" alt="" class="operationBg">
                </div>
            </div>
        </div>
        <!-- 权益保障 -->
        <div class="equity">
            <div class="equityCont">
                <p class="equityTit">权益保障</p>
                <div class="equityUl"> 
                    <span class="equityLi">
                        <img :src="guarantee" alt="">
                        <p>区域</p>
                        <span>运营的区域不重叠，</span>
                        <span>不交叉</span>
                    </span>
                    <span class="equityLi">
                        <img :src="guaranteeTwo" alt="">
                        <p>发单</p>
                        <span>发单仅限本区域，</span>
                        <span>供应不限</span>
                    </span>
                    <span class="equityLi">
                        <img :src="guaranteeThree" alt="">
                        <p>唯一</p>
                        <span>发单运营权均唯一，</span>
                        <span>保障主导权</span>
                    </span>
                    <span class="equityLi">
                        <img :src="guaranteeFour" alt="">
                        <p>所有</p>
                        <span>覆盖区域内所有大中</span>
                        <span>小用工企业，</span>
                        <span>完全自主</span>
                    </span>
                    <span class="equityLi">
                        <img :src="guaranteeFive" alt="">
                        <p>收益</p>
                        <span>享受区域内平台会员</span>
                        <span>一定比例收益</span>
                    </span>
                </div>
            </div>
        </div>
        <!-- 合作优势 -->
        <div class="teamwork">
            <div class="teamworkCont">
                <p class="teamworkTitle">合伙优势</p>
                <span class="teamworkTextCont">
                    <span class="teamworkTextContLi">
                        <span class="teamworkTextContLiTop"> 
                            <span>更短</span>
                            <img :src="decline" alt="">
                        </span>
                        <span class="teamworkTextContLiBottom">服务路径更短</span>
                    </span>
                    <span class="teamworkTextContLi">
                        <span class="teamworkTextContLiTop"> 
                            <span>更低</span>
                            <img :src="decline" alt="">
                        </span>
                        <span class="teamworkTextContLiBottom">拓客成本更低</span>
                    </span>
                    <span class="teamworkTextContLi">
                        <span class="teamworkTextContLiTop"> 
                            <span>更小</span>
                            <img :src="decline" alt="">
                        </span>
                        <span class="teamworkTextContLiBottom">信任成本更小</span>
                    </span>
                    <span class="teamworkTextContLi">
                        <span class="teamworkTextContLiTop"> 
                            <span>更高</span>
                            <img :src="rise" alt="">
                        </span>
                        <span class="teamworkTextContLiBottom">资源利用更高</span>
                    </span>
                    <span class="teamworkTextContLi">
                        <span class="teamworkTextContLiTop"> 
                            <span>更省</span>
                            <img :src="decline" alt="">
                        </span>
                        <span class="teamworkTextContLiBottom">交易成本更省</span>
                    </span>
                </span>
                <img :src="advantageBg" alt="" class="advantageBg">
            </div>
        </div>
        <!-- 加入好工网 -->
        <div class="joinJob">
            <div class="joinJobCont">
                <span class="joinLeft">
                    <p>加入好工网，全新升级</p>
                    <span class="joinText">
                        <span class="joinTextLi">
                            <span>效率升级</span><img :src="rise" alt="">
                        </span>
                        <span class="joinTextLi">
                            <span>模式升级</span><img :src="rise" alt="">
                        </span>
                        <span class="joinTextLi">
                            <span>收益升级</span><img :src="rise" alt="">
                        </span>
                    </span>
                    <span class="enterNow" @click="goEnter">立即入驻</span>
                </span>
                <span class="joinRight">
                    <span class="joinRightLi" style="margin-right:72px;">
                        <img :src="labour" alt="">
                        <span>好工网劳务版</span>
                    </span>
                    <span class="joinRightLi" style="margin-right:45px;">
                        <img :src="person" alt="">
                        <span>好工网会员版</span>
                    </span>
                    <span class="joinRightLi">
                        <img :src="miniwechat" alt="">
                        <span>好工网公众号/小程序</span>
                    </span>
                </span>
            </div>
        </div>
        <div class="cooperation">
            <img :src="cooperationLeftBg" alt="" class="cooperationLeftBg">
            <div class="cooperationCont">
                <span class="cooperationContLeft">
                    <img :src="logo06" alt="" class="logo">
                    <span class="process">合作流程</span>
                    <span class="joinMe">立即加入我们，因为你从来不是配角</span>
                    <span class="enterN" @click="goEnter">立即入驻</span>
                </span>
                <span class="cooperationContRight">
                    <img :src="cooperationContRigLog" alt="" class="cooperationContRigLog">
                    <span class="textCooperat">
                        <img :src="numberRight" alt="" class="numberRight">
                        <span class="textCooperatUl">
                            <span class="textCooperatLi">
                                <span class="textCooperatLiTit">提交申请</span>
                                <span class="textCooperatLiSpan">在线申请or拨打0755-89359799</span>
                            </span>
                            <span class="textCooperatLi">
                                <span class="textCooperatLiTit">客服受理</span>
                                <span class="textCooperatLiSpan">客服预审并提交意向表到商务，由商务部门进行洽谈</span>
                            </span>
                            <span class="textCooperatLi">
                                <span class="textCooperatLiTit">签约合作</span>
                                <span class="textCooperatLiSpan">确认合作意向并签约合作加盟协议</span>
                            </span>
                            <span class="textCooperatLi">
                                <span class="textCooperatLiTit">开通权限</span>
                                <span class="textCooperatLiSpan">根据合作类型开通相应的账号权限，授予相关证书和资质等</span>
                            </span>
                            <span class="textCooperatLi">
                                <span class="textCooperatLiTit">服务培训</span>
                                <span class="textCooperatLiSpan">开展相关产品培训，并提供运营、推广、营销策划支持等</span>
                            </span>
                        </span>
                    </span>
                </span>
            </div>
        </div>
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'"></footerPages> 
        <!-- 入驻弹窗 -->
        <div class="enterWindow" v-if="maskTrue">
            <div class="maskBack"></div>
            <div class="writeCont">
                <div class="writeTitle">填写资料，立即入驻</div>
                <div class="writeContBorder">
                    <div class="selectAndInput">
                        <label for="" class="labelName">我的身份</label>
                        <div class="boxTab">
                            <span v-for="(items,index) in tabs" :key="index" :class="curentIdent==index? 'activeIdentity identity':'identity'" @click="tabIdentity(index)">{{items}}</span>
                        </div>
                    </div>
                    <div class="selectAndInput phoneInput">
                        <label for="" class="labelName">我的姓名</label>
                        <input type="text" minlength="1" maxlength="6" placeholder="请输入" v-model="form.name">
                    </div>
                    <div class="selectAndInput phoneInput">
                        <label for="" class="labelName">联系方式</label>
                        <input  :class="phoneNumberStyle==true ? 'activeColor':''" type="number" placeholder="请输入手机号" oninput="if(value.length > 11)value = value.slice(0, 11)" v-model="form.phone">
                    </div>
                    <div class="wantSay">
                        <label for="" class="labelName">想说的话</label>
                        <textarea name="" v-model="form.applyReason" id="" cols="30" maxlength="200" placeholder="请填写您想和我们说的话" rows="10"></textarea>
                        <span>{{form.applyReason.length}}/200</span>
                    </div>
                    <div class="submit">
                        <div @click="submit" :disabled="!loading" :class="canSubmit==true ? 'btn-active':''">提  交</div>
                    </div>  
                </div>
                <span class="closeImg" @click="closeMask">
                    <img :src="closeImg" alt="">
                </span>
            </div>
        </div>
        <div class="taskShade" v-if="centerTaskTrue">
            <div class="centerTask">
                <p>提示</p>
                <span>{{testMessage}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import haojobLogo from '@/assets/haoojoblogo.svg'
import recruitBanner from '@/assets/investment/recruit-banner@2x.png'
import operationBg from '@/assets/investment/img02@2x.png'
import placeOther from '@/assets/investment/placeOther.png'
import thisPlace from '@/assets/investment/thisPlace.png'
import goldCoin from '@/assets/investment/GoldCoin@2x.png'
import guarantee from '@/assets/investment/guarantee_01region@2x.png'
import guaranteeTwo from '@/assets/investment/guarantee_02bill@2x.png'
import guaranteeThree from '@/assets/investment/guarantee_03one@2x.png'
import guaranteeFour from '@/assets/investment/guarantee_04all@2x.png'
import guaranteeFive from '@/assets/investment/guarantee_05profit@2x.png'
import advantageBg from '@/assets/investment/advantage_bg@2x.png'
import decline from '@/assets/investment/decline@2x.png'
import rise from '@/assets/investment/rise@2x.png'
import labour from '@/assets/investment/labour.png'
import miniwechat from '@/assets/investment/miniwechat.png'
import person from '@/assets/investment/person.png'
import cooperationLeftBg from '@/assets/investment/bg06@2x.png'
import logo06 from '@/assets/investment/logo06@2x.png'
import cooperationContRigLog from '@/assets/investment/logo_line@2x.png'
import numberRight from '@/assets/investment/szyd@2x.png'
import closeImg from '@/assets/close@3x.png'
import api from '@/api'

export default {
    
    data(){
        return {
            closeImg,
            testMessage:'客服将在1～3个工作日内联系您，请您保持电话畅通',
            centerTaskTrue:false,
            curentIdent:0,
            maskTrue:false,
            typeName:'请选择',
            loading:true,
            tabs: ['劳务公司','招聘门店','招聘专员'],
            form:{
                type:'',
                name:'',
                phone:'',
                applyReason:'',
                sourceType:2,
            },

            recruitBanner,
            appTrueActive:false,
            haojobLogo,
            operationBg,
            placeOther,
            thisPlace,
            goldCoin,
            guarantee,
            guaranteeTwo,
            guaranteeThree,
            guaranteeFour,
            guaranteeFive,
            advantageBg,
            decline,
            rise,
            labour,
            miniwechat,
            person,
            cooperationLeftBg,
            logo06,
            cooperationContRigLog,
            numberRight,
        }
    },
    computed:{
        // 用于校验手机号码格式是否正确
        phoneNumberStyle(){
            let reg = /^1[3456789]\d{9}$/
            if(!reg.test(this.form.phone)){
                return false
            }
            return true
        },
        canSubmit(){
            console.log(11,this.form.type,this.form.name,this.phoneNumberStyle)
            if(this.phoneNumberStyle && this.form.name){
                return true
            }else{
                return false
            }
        },
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        wow.init();
    },
    methods:{
        tabIdentity(index){
            this.curentIdent=index
        },
        goEnter(){
            this.maskTrue=true
        },
        closeMask(){
            this.maskTrue=false
        },
        appDownload(){//移入App下载
            this.appTrueActive=true
        },
        leaveDownload(){
            this.appTrueActive=false
        },
        async submit(){
            let that = this
            if(this.curentIdent==0){
                this.form.type=3
            }else if(this.curentIdent==1){
                this.form.type=1
            }else if(this.curentIdent==2){
                this.form.type=0
            }
            this.loading=true
            if(this.canSubmit&&this.loading){
                this.loading=false
                let res = await api.roleApplySave(this.form)
                if(res.code==200){
                    this.maskTrue=false
                    that.centerTaskTrue=true
                    setTimeout(function(){
                        that.centerTaskTrue=false
                    },3000)
                }else{
                    this.maskTrue=false
                    that.centerTaskTrue=true
                    setTimeout(function(){
                        that.centerTaskTrue=false
                    },3000)
                    this.testMessage=res.message
                }
                console.log(res)
            }
        },
    }
}
</script>
<style scoped lang="less">
    .taskShade{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        z-index: 1000;
    }
    .centerTask{
        width: 450px;
        background: rgba(0,0,0,.6);
        border-radius: 10px;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 30px;
    }
    .centerTask>p{
        width: 100%;
        text-align: center;
        font-size: 30px;
        line-height: 46px;
        color: #fff;
        margin-top: 15px;
        margin-bottom: 19px;
    }
    .centerTask>span{
        color: #fff;
        font-size: 26px;
        line-height: 40px;
        text-align: center;
        display: block;
    }
    .oneBannerHome{
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    
    .header{
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .centerFloat{
        width: 100%;
        position: relative;
        height: 520px;
        background: #fff;
        margin: 0 auto;
        overflow: hidden;
        .centerHead{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
            position: relative;
            z-index: 100;
            .content{
                float: right;
                margin-top: 160px;
                .titleOne{
                    font-size: 48px;
                    display: block;
                    font-weight: bold;
                    color: #1D5EEA;
                    line-height: 60px;
                }
                .analyse{
                    font-size: 16px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 36px;
                }
                .atOnce{
                    width: 300px;
                    height: 60px;
                    background: #1D5EEA;
                    text-align: center;
                    line-height: 60px;
                    color: #fff;
                    display: block;
                    margin-top: 35px;
                    cursor: pointer;
                    font-size: 24px;
                }

            }
        }
        .bannerBg{
            width: 100%;
            height: 520px;
            overflow: hidden;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
    .operation{
        width: 100%;
        height: auto;
        position: relative;
        z-index: 1000;
        .operationSear{
            width: 1200px;
            height: 860px;
            margin: 0 auto;
            padding-top: 100px;
            box-sizing: border-box;
            position: relative;
            .operationTit{
                font-size: 48px;
                font-weight: 500;
                color: #222222;
                line-height: 54px;
                text-align: center;
                margin-bottom: 30px;
            }
            .operationCont{
                width: 100%;
                height: auto;
                .operationBg{
                    width: 672px;
                    height: 740px;
                    display: block;
                    float: right;
                    position: absolute;
                    bottom: -78px;
                    right: 0;
                }
                .operatLeft{
                    float: left;
                    margin-top: 92px;
                    margin-left: 5px;
                    .operatLi{
                        width: 430px;
                        height: 200px;
                        display: block;
                        margin-bottom: 42px;
                        background: #FFFFFF;
                        overflow: hidden;
                        padding-left: 30px;
                        box-sizing: border-box;
                        box-shadow: 0px -5px 14px 0px rgba(188, 201, 218, 0.14), 0px 5px 12px 0px rgba(190, 200, 215, 0.2), 0px 10px 100px 0px rgba(222, 223, 225, 0.1);
                        .operatLiDt{
                            display: flex;
                            float: left;
                            height: 160px;
                            flex-direction: column;
                            width: 200px;
                            justify-content: space-evenly;
                            span{
                                display: block;
                            }
                            span:first-child{
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                                line-height: 30px;
                            }
                            span:nth-child(2){
                                font-size: 16px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 28px;
                            }
                            img{
                                width: 30px;
                                height: 30px;
                                display: block;
                            }
                        }
                        .rightImg{
                            width: 160px;
                            height: 160px;
                            display: block;
                            float: right;
                        }
                    }
                }
            }
        }
    }
    .equity{
        width: 100%;
        height: 710px;
        overflow: hidden;
        background: #1D5EEA;
        position: relative;
        z-index: 999;
        .equityCont{
            width: 1200px;
            height: auto;
            overflow: hidden;
            margin: 0 auto;
            .equityTit{
                font-size: 48px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 54px;
                text-align: center;
                margin-top:105px;
                margin-bottom: 65px;
            }
            .equityUl{
                width: 100%;
                height: auto;
                overflow: hidden;
                .equityLi{
                    width: 220px;
                    height: 350px;
                    background: #fff;
                    margin-right: 25px;
                    display: flex;
                    padding-top: 60px;
                    box-sizing: border-box;
                    align-items: center;
                    flex-direction: column;
                    float: left;
                    img{
                        width: 80px;
                        height: 80px;
                        display: block;
                        margin-bottom: 36px;
                    }
                    p{
                        font-size: 24px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 30px;
                        margin-bottom: 15px;
                    }
                    span{
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 30px;
                    }
                }
                .equityLi:last-child{
                    margin-right: 0;
                }
            }
        }
    }
    .teamwork{
        width: 100%;
        height: 610px;
        overflow: hidden;
        background: #EAF0FF;
        position: relative;
        .teamworkCont{
            width: 1200px;
            height: 610px;
            overflow: hidden;
            margin: 0 auto;
            position: relative;
            .teamworkTitle{
                text-align: center;
                font-size: 48px;
                font-weight: 500;
                color: #333333;
                line-height: 54px;
                margin-top: 117px;
            }
            .advantageBg{
                width: 1200px;
                height: 300px;
                position: absolute;
                bottom: 0;
                right: 0;
                left: 0;
                z-index: 100;
            }
            .teamworkTextCont{
                width: 100%;
                height: auto;
                overflow: hidden;
                display: flex;
                margin-top: 55px;
                .teamworkTextContLi{
                    width: 25%;
                    text-align: center;
                    display: block;
                    .teamworkTextContLiTop{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        span{
                            font-size: 24px;
                            font-weight: bold;
                            color: #333333;
                            line-height: 54px;
                            float: left;
                            display: block;
                        }
                        img{
                            width: 16px;
                            height: 20px;
                            display: block;
                            margin-left: 10px;
                        }
                    }
                    .teamworkTextContLiBottom{
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 30px;
                    }
                }
            }
        }
    }
    .joinJob{
        width: 100%;
        height: auto;
        overflow: hidden;
        .joinJobCont{
            width: 1200px;
            height: 220px;
            margin: 0 auto;
            overflow: hidden;
            .joinLeft{
                float: left;
                display: flex;
                flex-direction: column;
                p{
                    font-size: 28px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 32px;
                    margin-top: 42px;
                    margin-bottom: 16px;
                }
                .joinText{
                    width: auto;
                    display: block;
                    height: 20px;
                    padding: 1px 0;
                    box-sizing: border-box;
                    overflow: hidden;
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 20px;
                    .joinTextLi{
                        float: left;
                        margin-right: 39px;
                        span{
                            float: left;
                            margin-right: 10px;
                        }
                        img{
                            width: 15px;
                            display: block;
                            float: left;
                            height: 18px;
                        }
                    }
                }
                .enterNow{
                    width: 150px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 20px;
                    color: #1D5EEA;
                    background: #fff;
                    cursor: pointer;
                    border: 1px solid #1D5EEA;
                    margin-top: 26px;
                }
            }
            .joinRight{
                float: right;
                margin-top: 56px;
                overflow: hidden;
                .joinRightLi{
                    width: auto;
                    height: 124px;
                    overflow: hidden;
                    float: left;
                    img{
                        width: 80px;
                        height: 80px;
                        display: block;
                        margin: 0 auto;
                    }
                    span{
                        line-height: 44px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
        }
    }
    .cooperation{
        width: 100%;
        height: 690px;
        overflow: hidden;
        background: #1D5EEA;
        position: relative;
        .cooperationLeftBg{
            width: 826px;
            height: 690px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 110;
        }
        .cooperationCont{
            width: 1200px;
            height: auto;
            position: relative;
            margin: 0 auto;
            .cooperationContLeft{
                width: 490px;
                display: flex;
                overflow: hidden;
                margin-top: 76px;
                position: inherit;
                z-index: 111;
                flex-direction: column;
                align-items: center;
                float: left;
                .logo{
                    width: 248px;
                    height: 286px;
                    display: block;
                }
                .process{
                    font-size: 48px;
                    font-weight: 500;
                    color: #222222;
                    line-height: 54px;
                    margin-top: 35px;
                }
                .joinMe{
                    font-size: 18px;
                    font-weight: 500;
                    color: #222222;
                    line-height: 24px;
                    margin-top: 10px;
                    margin-bottom: 20px;
                }
                .enterN{
                    width: 200px;
                    height: 60px;
                    background: #1D5EEA;
                    display: block;
                    text-align: center;
                    line-height: 60px;
                    color: #fff;
                    font-size: 24px;
                    cursor: pointer;
                }
            }
            .cooperationContRight{
                float: right;
                position: relative;
                padding-top: 90px;
                padding-right: 80px;
                box-sizing: border-box;
                .cooperationContRigLog{
                    position: absolute;
                    top: 0;
                    right: -108px;
                    width: 285px;
                    height: 152px;
                    display: block;
                }
                .textCooperat{
                    .numberRight{
                        width: 84px;
                        height: 488px;
                        display: block;
                        float: left;
                    }
                    .textCooperatUl{
                        width: auto;
                        height: 500px;
                        margin-top: -5px;
                        display: flex;
                        padding-left: 24px;
                        box-sizing: border-box;
                        flex-direction: column;
                        justify-content: space-between;
                        .textCooperatLi{
                            display: block;
                            .textCooperatLiTit{
                                font-size: 24px;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 28px;
                                display: block;
                                margin-bottom: 8px;
                            }
                            .textCooperatLiSpan{
                                font-size: 16px;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 18px;
                                display: block;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
    }
    .enterWindow{
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 10000;
        justify-content: center;
        align-items: center;
        display: flex;
        .maskBack{
            background: rgba(0, 0, 0, 0.4);
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 99;    
        }
        .writeCont{
            width: 700px;
            max-width: 700px;
            background: #fff;
            position: relative;
            overflow-y: auto;
            z-index: 100;
            padding: 60px 80px;
            box-sizing: border-box;
            position: fixed;
            top: 60px;
            bottom: 60px;
            .writeTitle{
                width: 100%;
                font-size: 30px;
                font-weight: 500;
                color: #222222;
                line-height: 76px;
            }
            .writeContBorder{
                width: 100%;
                height: auto;
                overflow: hidden;
                margin-top: 30px;
                .selectAndInput{
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    margin-top: 20px;
                    .boxTab{
                        width: 450px;
                        height: 50px;
                        line-height: 50px;
                        overflow: hidden;
                        float: right;
                        .identity{
                            width: 33.3%;
                            cursor: pointer;
                            height: 50px;
                            text-align: center;
                            float: left;
                            border: 1px solid #CCCCCC;
                            box-sizing: border-box;
                        }
                        .identity:nth-child(2),.identity:nth-child(1){
                            border-right: 0;
                        }
                        .activeIdentity{
                            background: #1D5EEA;
                            color: #fff;
                        }
                    }
                    .labelName{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 50px;
                        float: left;
                    }
                    input{
                        width: 450px;
                        height: 50px;
                        float: right;
                        font-size: 18px;
                        color: #333;
                        padding: 0 19px;
                        box-sizing: border-box;
                        overflow: hidden;
                        border: 1px solid #ccc;
                        outline: none;
                    }
                    input::placeholder{
                        color: #CCCCCC;
                    }
                }
                .wantSay{
                    margin-top: 20px;
                    overflow: hidden;
                    position: relative;
                    span{   
                        font-size: 18px;
                        font-weight: 500;
                        color: #CCCCCC;
                        position: absolute;
                        bottom: 15px;
                        right: 15px;
                    }
                    .labelName{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 50px;
                        float: left;
                    }
                    textarea{
                        float: right;
                        width: 450px;
                        font-size: 18px;
                        height: 200px;
                        border: 1px solid #ccc;
                        padding: 20px;
                        box-sizing: border-box;
                        line-height: 30px;
                        resize:none;
                        outline: none;
                    }
                }
                .submit{
                    div{
                        width: 450px;
                        height: 56px;
                        background: #1D5EEA;
                        font-size: 20px;
                        font-weight: 500;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 56px;
                        float: right;
                        margin-top: 32px;
                        cursor: pointer;
                        opacity: 0.3;
                    }
                    .btn-active{
                        opacity: 1;
                    }
                }
            }
            .closeImg{
                width: 40px;
                height: 40px;
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img{
                    width: 15px;
                    height: 15px;
                    display: block;
                }
            }
        }
        .successWindow{
            height: 351px;
        }
    }
</style>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>